import { render, staticRenderFns } from "./StudentComponent.vue?vue&type=template&id=75f440b9&"
import script from "./StudentComponent.vue?vue&type=script&lang=js&"
export * from "./StudentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports